import template from './price-multi-sale.jade';
import currencies from '../../../enums/currency';
import validation from '../../../services/validation';
import { numberToPrettyString } from '@cian/utils';
import { initializeSegmentInputTooltips } from '../../../utils/segment-input-tooltips';
import { isAreaPartsEnabled } from '../../../../../../shared/utils';

export default angular
  .module('cian.addForm.priceMultiSale', [])
  .directive('cianAfPriceAndDealTermsPriceMultiSale', () => ({
    scope: {},
    bindToController: {
        ad: '=',
        form: '=',
        priceLimit: '@?',
    },
    controller: [
      '$scope', 'categoryService', 'adTooltipsService', 'analyticsService', 'deviceService', 'popupService',
      function(
        $scope, categoryService, adTooltipsService, analyticsService, deviceService, popupService,
      ) {
      this.isMobile = deviceService.isMobile;
      this.tooltipText = '';
      this.ad.bargainTerms = this.ad.bargainTerms || {};
      this.isPartsEnabled = isAreaPartsEnabled(this.ad);
      this.valueMin = 0;
      this.valueMax = this.priceLimit ? Number(this.priceLimit) : 10e9;
      this.inputPattern = angular.isDefined(this.allowZero) ? /^[0-9]+/ : /^[1-9]{1}[0-9]{0,}/;
      this.getIsRent = () => {
        const { paymentPeriod } = this.ad.bargainTerms;
        return paymentPeriod === 'annual' || paymentPeriod === 'monthly';
      };

      this.getTotalArea = () => {
        const { objectType } = categoryService.getInfoByCategory(this.ad.category);
        switch (objectType) {
          case 'building':
            return this.ad.building.totalArea || this.ad.totalArea;
          case 'commercialLand':
            return this.ad.land.area;
          default:
            return this.ad.totalArea;
        }
      };

      this.getComputedRate = () => {
        const { price } = this.ad.bargainTerms;
        const totalArea = this.getTotalArea();
        return price && totalArea ? price / totalArea : null;
      };

      const getFormatPrice = (area, priceType, paymentPeriod, price, currencySymbol, isAll) => {
        const allTitle = isAll && !this.getIsRent(paymentPeriod) ? ' за всё' : '';
        const rentMonthTitle = this.getIsRent(paymentPeriod) ? '/мес.' : '';

        if (priceType === 'all') {
          const result = numberToPrettyString(Math.round(price / area));
          return price && area && ` ${result} ${currencySymbol && currencySymbol.name} за м&sup2;`;
        } else if (priceType === 'squareMeter' && paymentPeriod === 'annual') {
          const result = numberToPrettyString(Math.round((price * area) / 12));
          return price &&
            area &&
            `за м&sup2;, ${result} ${currencySymbol && currencySymbol.name}${rentMonthTitle}${allTitle}`;
        } else if (priceType === 'squareMeter') {
          const result = numberToPrettyString(Math.round(price * area));
          return price &&
            area &&
            `за м&sup2;, ${result} ${currencySymbol && currencySymbol.name}${rentMonthTitle}${allTitle}`;
        }

        return '';
      };

      this.getDescPartPrice = (index) => {
        const { price, area } = this.ad.areaParts[index];
        const { currency, priceType, paymentPeriod } = this.ad.bargainTerms;
        const currencySymbol = currencies.find(t => t.key === currency);

        return getFormatPrice(area, priceType, paymentPeriod, price, currencySymbol);
      };

      this.getDescTotalPrice = () => {
        const totalArea = this.getTotalArea();
        const { price, currency, priceType, paymentPeriod } = this.ad.bargainTerms;
        const currencySymbol = currencies.find(t => t.key === currency);

        return getFormatPrice(totalArea, priceType, paymentPeriod, price, currencySymbol, true);
      };

      this.validation = validation(this.form, 'bargainTerms.price', {
        parse: 'Введите число',
        required: 'Не указана стоимость',
        min: 'Цена должна быть больше 0',
        max: 'Допустимо не более 10 символов',
      });

      this.makeStringPath = (index) => `areaParts.${index}.price`;
      this.partValidations = [...Array(10)].map((item, index) => {
        const messages = {
          parse: 'Введите число',
          min: `Цена ${index + 1} должна быть больше 0`,
          max: `Цена ${index + 1} не может быть больше общей площади`,
        };
        return validation(this.form, this.makeStringPath(index), messages);
      });

      this.isCorrectArea = (area) => {
        const { totalArea } = this.ad;

        return area.area > 0 && area.area <= totalArea;
      };

      this.isShowPriceParts = (area) => {
        const { areaParts } = this.ad;

        return areaParts && areaParts.length > 0 && this.isCorrectArea(area);
      };

      this.getTitleField = () => this.getIsRent() ? 'Арендная плата' : 'Цена';

      initializeSegmentInputTooltips({
        controller: this,
        $scope,
        adTooltipsService,
        adAnalyticsCategory: analyticsService.adAnalyticsCategory,
        tooltipsKey: 'bargainTerms.price',
        trackingLabel: 'price-sale-hint',
        popupService,
        isMobile: this.isMobile,
      });
    }],
    controllerAs: 'ctrl',
    template,
  }))
  .name;
